import { type IDropdownItem } from 'shared/ui'
import { type Inbox } from 'entities/Inbox/model/Inbox'
import { type GroupInbox } from 'entities/Inbox/model/GroupInbox'
import { type ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

const typeNewFolder = 'new_folder'

type IActionNewFolder = {
  inbox: Inbox
  groupInbox?: GroupInbox
  item: IDropdownItem
}

export const menuNewFolder = (): IDropdownItem => {
  return {
    id: typeNewFolder,
    iconL: 'add',
    label: 'New folder',
  }
}

export const actionNewFolder = (
  { inbox, groupInbox, item }: IActionNewFolder,
  store: ConversationMenuStore
) => {
  if (item.id === typeNewFolder) {
    store.groupsApiMenuStore.onAddTeamsGroupsCreateLocal({ inbox, groupInbox })
  }
}
